<template>
  <div>
    <h5 class="card-title pl-1">{{ $t('checkup_plus.reports.patient_overall_summary.title') }}</h5>

    <div class="grid-container mb-3">
      <div class="summary-card" v-for="elem in data.results">
        <div class="title-container d-flex align-items-center">
          <img style="margin-right: 10px" :src="require(`@/assets/check-up-reports/evollu-default/${elem.slug.toLowerCase()}.svg`)">
          <div>
            <!--<h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.geriatric_parameters') }}</h5>-->
            <h5 class="card-title">{{ $t(`checkup_plus.reports.patient_overall_summary.${elem.slug.toLowerCase()}`) }}</h5>
          </div>
        </div>
        <SummaryProgressBar :success="elem.currentNormal" :missed="elem.currentNotNormal" :total="elem.totalParameters" class="mt-2"/>
        <span class="card-description">
            <span style="font-weight: bold">{{elem.previousNormal}}/{{elem.previousNotNormal}}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
          </span>
      </div>
    </div>

    <!--<table>
      <tr>
        <td>
          <div class="summary-card">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/biometric_parameters.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.biometric_parameters') }}</h5>
              </div>
            </div>
            <SummaryProgressBar :success="10" :missed="2" :total="20" class="mt-2"/>
            <span class="card-description">
            <span style="font-weight: bold">2/10</span> on the last test
          </span>
          </div>
        </td>

        <td>
          <div class="summary-card">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/geriatric_parameters.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.geriatric_parameters') }}</h5>
              </div>
            </div>
            <SummaryProgressBar :success="10" :missed="2" :total="20" class="mt-2"/>
            <span class="card-description">
            <span style="font-weight: bold">2/10</span> on the last test
          </span>
          </div>
        </td>
      </tr>

      <tr>
        <td>
          <div class="summary-card">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/audiology_parameters.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.audiology_parameters') }}</h5>
              </div>
            </div>
            <SummaryProgressBar :success="10" :missed="2" :total="20" class="mt-2"/>
            <span class="card-description">
            <span style="font-weight: bold">2/10</span> on the last test
          </span>
          </div>
        </td>

        <td>
          <div class="summary-card">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/optometry_parameters.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.optometry_parameters') }}</h5>
              </div>
            </div>
            <SummaryProgressBar :success="10" :missed="2" :total="20" class="mt-2"/>
            <span class="card-description">
            <span style="font-weight: bold">2/10</span> on the last test
          </span>
          </div>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <div class="summary-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/recommendation_checkmark.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              We recommend incorporating regular Evollu health check-ups into your routine and proactively sharing the findings with your healthcare provider for a comprehensive approach to maintaining good health.
            </span>
          </div>
        </td>
      </tr>
    </table>-->



  </div>

</template>

<script>
import SummaryProgressBar from "@/components/checkup_plus/patients/Report/Contents/SummaryProgressBar.vue";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  components: {SummaryProgressBar}
}
</script>

<style scoped lang="scss">
.summary-card {
  padding: 20px;
  width: 49%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}


.card-text-bold {
  color: black
}

.card-text-normal {
  color: #6a6a6a
}

table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  width: 33.33%;
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

.grid-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 5px;
}
</style>
